var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Wiki löschen'),"showDrawer":false,"lastPath":-1,"tooltipMessage":"Hier können Sie Wiki Einträge löschen"}}),_c('ConfirmDelete',{attrs:{"deleteMessage":_vm.$t('Sind Sie sicher, dass Sie diesen Wiki Ordner löschen wollen?'),"selectedItem":_vm.wiki},on:{"deleteItem":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }